module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-header', {
    attrs: {
      "left-options": {
        showBack: false
      }
    }
  }, [(true) ? _c('a', {
    attrs: {
      "slot": "left"
    },
    on: {
      "click": function($event) {
        _vm.goTodo()
      }
    },
    slot: "left"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "slot": "label",
      "src": require("../assets/icon/back.png"),
      "width": "18",
      "height": "18"
    },
    slot: "label"
  }), _vm._v(" "), _c('span', {
    staticClass: "jump-back",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("返回")])]) : _vm._e(), _vm._v("\n    " + _vm._s(_vm.pageTitle) + "\n    "), (!_vm.userName) ? _c('a', {
    attrs: {
      "slot": "right"
    },
    on: {
      "click": function($event) {
        _vm.goLogin()
      }
    },
    slot: "right"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "slot": "label",
      "src": require("../assets/icon/user-white.png"),
      "width": "18",
      "height": "18"
    },
    slot: "label"
  })]) : _vm._e(), _vm._v(" "), (_vm.userName) ? _c('a', {
    attrs: {
      "slot": "right"
    },
    on: {
      "click": function($event) {
        _vm.goLogin()
      }
    },
    slot: "right"
  }, [_vm._v("\n      " + _vm._s(_vm.userName) + "\n    ")]) : _vm._e()]), _vm._v(" "), _c('group', {
    staticStyle: {
      "margin-top": "46px"
    }
  }, _vm._l((_vm.noticeData.list), function(item) {
    return _c('cell-box', {
      key: item.id,
      attrs: {
        "is-link": "",
        "link": {
          path: '/content',
          query: {
            id: item
          }
        }
      }
    }, [_c('flexbox', [_c('flexbox-item', [_c('div', {
      staticClass: "flex-demo home-list-title"
    }, [_c('p', {
      staticClass: "item-p"
    }, [_vm._v(_vm._s(item.title))])])]), _vm._v(" "), _c('flexbox-item', [_c('div', {
      staticClass: "flex-demo home-list-date"
    }, [_vm._v(_vm._s(item.sendTime.substr(0, 10)))])])], 1)], 1)
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a7f9541","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/Notice.vue
// module id = JdqS
// module chunks = 0